import { Injectable } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { ProductsService } from '@core/services/products/products.service';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { DetailsComponent } from '@shared/modals/details/details.component';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';

@Injectable({ providedIn: 'root' })
export class AboutCommand extends BaseProductCommand {
  private readonly titleMap = {
    [ProductTypes.ACCOUNT]: 'О счете',
    [ProductTypes.SAVE_ACCOUNT]: 'О счете',
    [ProductTypes.METAL_ACCOUNT]: 'О счете',
    [ProductTypes.CARD]: 'О карте',
    [ProductTypes.CREDIT]: 'О кредите',
    [ProductTypes.DEPOSIT]: 'Условия вклада'
  } as const;

  readonly type = 'about';
  readonly icon = 'info';
  readonly productType: ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.CARD,
    ProductTypes.CREDIT,
    ProductTypes.DEPOSIT,
    ProductTypes.SAVE_ACCOUNT,
    ProductTypes.METAL_ACCOUNT
  ];

  readonly isInfoAction = true;
  readonly settingsNames = undefined; // Нет серверных настроек для этой команды
  readonly fallbackTitle = 'О продукте';

  get title(): string {
    // Используем метод из BaseProductCommand
    return this.getContextualTitle(this.titleMap, this.fallbackTitle);
  }

  get order(): number {
    return this.getContextualOrder(
      {
        [ProductTypes.ACCOUNT]: 10, // Счет: О счёте (1-й в списке "прочее")
        [ProductTypes.SAVE_ACCOUNT]: 10, // Накопительный счет: О счёте (1-й в списке "прочее")
        [ProductTypes.METAL_ACCOUNT]: 10, // Металлический счет: О счёте (1-й в списке "прочее")
        [ProductTypes.CARD]: 50, // Карты: О карте (5-й в списке "прочее")
        [ProductTypes.CREDIT]: 30, // Кредит: О кредите (3-й в списке "прочее")
        [ProductTypes.DEPOSIT]: 10 // Вклад: Условия вклада (1-й в списке "прочее")
      },
      999
    );
  }

  constructor(
    private modalCtrl: ModalController,
    private productsService: ProductsService
  ) {
    super(); // Не передаем CommandAvailabilityService, так как он не нужен
  }

  async execute(context: IProductCommandContext): Promise<void> {
    const aboutInfo = await this.productsService.getProductAbout(context.data.id);
    const modal = await this.modalCtrl.create({
      component: DetailsComponent,
      handle: false,
      initialBreakpoint: 1,
      cssClass: 'modal-height-fix custom',
      componentProps: {
        fields: aboutInfo.data
      }
    });

    await modal.present();
  }
}
